export const MIN_TIMELINE_ROWS_COUNT = 10;